const auth = (state = {
    masterToken: undefined,
    teamTokens: [],
    teamUrl: undefined,
    signingUp: undefined
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'AUTH_DETAILS_FETCH_SUCCEEDED':
            if (!action.payload.details) {
                return state;
            }

            return Object.assign({}, state, action.payload.details);

        case 'RESET_STORE':
            return Object.assign({}, state, {
                masterToken: undefined,
                teamTokens: [],
                teamToken: undefined,
                teamUrl: undefined
            });

        case 'AUTH_DETAILS_SET_REQUESTED':
            return Object.assign({}, state, {
                masterToken: action.payload.masterToken,
                teamToken: action.payload.teamToken,
                teamUrl: action.payload.teamUrl
            });

        case 'MASTER_TOKEN_SET_REQUESTED':
            return Object.assign({}, state, {
                masterToken: action.payload.masterToken
            });

        case 'TEAM_TOKEN_SET_REQUESTED':
            return Object.assign({}, state, {
                teamToken: action.payload.teamToken,
                teamUrl: action.payload.teamUrl
            });

        case 'TEAM_URL_SET_REQUESTED':
            return Object.assign({}, state, {
                teamUrl: action.payload.teamUrl
            });

        case 'LOGGING_OUT':
            return Object.assign({}, state, {
                loggingOut: true
            });

        case 'SIGNING_UP':
            return Object.assign({}, state, {
                signingUp: true
            });

        case 'SIGNED_UP':
            return Object.assign({}, state, {
                signingUp: false
            });

        case 'UPDATE_CURRENT_USER_PASSWORD':
        case 'UPDATE_CURRENT_USER_EMAIL':
            return Object.assign({}, state, {
                masterToken: action.payload.token
            });

        default:
            return state;
    }
}

export default auth;
